var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"btn",class:_vm.variantClass},_vm.listeners),[_vm._t("default"),_c('i',{class:_vm.iconClass})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }